<template>
  <div id="app">
    <router-view />
    <Spin size="large" fix v-if="this.$store.state.isShowSpin"></Spin>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
.ivu-spin-fix {
  z-index: 999 !important;
}
::-webkit-scrollbar {
  width: 0px;
  height: 0px;
  background-color: #fff;
}
::-webkit-scrollbar-thumb {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: rgba(0, 0, 0, 0.1);
}
</style>



// WEBPACK FOOTER //
// src/App.vue